import { bindUrl, request } from "./request";

export function reqGet(bodyParams) {
    return request({
        url: bindUrl("/blade-resource/captcha/get", {}),
        method: "POST",
        data: bodyParams
    });
}
export function reqCheck(bodyParams) {
    return request({
        url: bindUrl("/blade-resource/captcha/check", {}),
        method: "POST",
        data: bodyParams
    });
}
